// Module
var code = "<h1 id=\"import-users\">Import Users</h1> <p>Any new list of users are imported to the SIS from a CSV file here.</p> <p><em>Note</em>: If the users are already on the system, they will be duplicated.</p> ";
// Exports
module.exports = code;